import { Box,Typography } from "@mui/material"
import { colors } from "../Theme/tokens"

export default function TooltipContent ({title,description}) {
  return(
      <Box sx={{ p: 0.5 }}>
    <Typography
      sx={{
        fontWeight: "600",
        fontSize: "12px",
        color: colors.text.third,
        mb: 0.5,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontWeight: "400",
        fontSize: "12px",
        color: colors.text.secondary,
        letterSpacing: "0.01em",
      }}
    >
      {description}
    </Typography>
  </Box>
  )
}